import { ContentCut } from "@mui/icons-material";
import { useStore } from "@priolo/jon";
import ButtonCmp from "components/controls/buttons/ButtonCmp";
import { FunctionComponent } from "react";
import dialogSo, { CYCLE_EDIT_TYPE } from "stores/cycle/editDialog";
import draftSo from "stores/draft";



interface Props {
}

/**
 * Il bottone che permette lo split di un CYCLE
 * in corrispondenza del LAYER selezionato
 */
const SplitButton: FunctionComponent<Props> = ({
}) => {

	// STORE
	useStore(dialogSo)

	// HOOKs

	// HANDLERs
	const handleSplit = async () => {
		await dialogSo.split()
		dialogSo.close(CYCLE_EDIT_TYPE.CLOSE)
	}

	// RENDER
	const isEditable = draftSo.isEditable()
	const layerSelected = dialogSo.state.layersNumberSelected != null && dialogSo.state.layersNumberSelected.length > 0
	const tooltip = !isEditable ? "CANNOT SPLIT IN READ-ONLY MODE" 
		: !layerSelected ? "SELECT A LAYER TO SPLIT" 
		: null

	return (
		<ButtonCmp
			tooltip={tooltip}
			disabled={!layerSelected || !isEditable}
			startIcon={<ContentCut />}
			onClick={handleSplit}
		>SPLIT</ButtonCmp>
	)
}

export default SplitButton
